/** Parse an aspect ratio string (e.g. "16:9", "2.35:1") into a numeric width/height ratio.
 *  Returns 0 if the string cannot be parsed. */
export function parseAspectRatio(ar: string): number {
  const parts = ar.split(':');
  if (parts.length === 2) {
    const w = parseFloat(parts[0]);
    const h = parseFloat(parts[1]);
    if (w > 0 && h > 0) return w / h;
  }
  return 0;
}
